import router from "./route";
import NProgress from "nprogress";
import getPageTitle from "./utils/getPageTitle";
// import store from "./store";
// 判断是否有路由访问权限
// const permissionControl = (to, next) => {
//   let hasPermission =
//     store.getters.menuName.includes(to.name) ||
//     store.getters.menuName.includes(to.meta.parentName);
//   if (hasPermission || to.path === "/home" || to.path === "/login") {
//     next();
//   } else {
//     to.path === "/404" ? next() : next("/404");
//   }
//   NProgress.done();
// };
// 全局前置守卫
router.beforeEach((to, from, next) => {
  NProgress.start();
  let hasToken = sessionStorage.getItem("token");
  // 动态更改文档标题
  // document.title = getPageTitle(to.name);
  if (hasToken) {
      // 如果刷新了页面就重新获取菜单列表
    // if (!store.getters.menuList.length) {
    //   store.dispatch("menu/getMenuList").then(() => {
    //     permissionControl(to, next);
    //   });
    // } else {
    //   permissionControl(to, next);
    // }
    //隐藏原来的
    document.title = getPageTitle(to.name);
    next();
    NProgress.done();
  } else {
    if (to.path === "/login") {
      document.title = '农电云库后台管理系统'
      next();
      NProgress.done();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});
// router.beforeEach((to, from, next) => {
//     NProgress.start();
//     let hasToken = sessionStorage.getItem("token");
//     if (hasToken) {
//       document.title = getPageTitle(to.name);
//       next();
//       NProgress.done();
//     } else {
//       if (to.path === "/login") {
//         next();
//         NProgress.done();
//       } else {
//         next("/login");
//         NProgress.done();
//       }
//     }
//   });
// router.afterEach(() => {
//   NProgress.done();
// });
